/* eslint-disable @typescript-eslint/no-explicit-any -- any used for generic */

import type { Steps } from '../MultiStepForm';
import type { ComponentMap, CDStep, ComponentSubmitDataId } from './types';

export function mapBEStepsToMultiFormSteps({
  flowId,
  componentMap,
  beSteps,
  onComponentSubmit,
}: {
  flowId: string;
  componentMap: ComponentMap;
  beSteps: CDStep[];
  onComponentSubmit: ComponentSubmitDataId;
}): Steps<React.FC<any>[][]> {
  return beSteps.map((s) => ({
    id: s.id,
    name: s.name,
    steps: s.steps.map((p) => {
      const comp = componentMap[p.name];
      if (!comp) {
        throw new Error(`Component not found for ${p.name}`);
      }
      return {
        id: p.id,
        name: comp.name,
        component: comp.component,
        props: {
          onSubmit: (x: unknown) => onComponentSubmit(x, p.dataId),
          config: p.requestContext,
          initialValues: p.initialValues,
          flowId,
          onUpdate: (x: unknown) => onComponentSubmit(x, p.dataId),
        },
        completed: p.completed,
        locked: p.locked,
        fullwidth: p.fullwidth,
      };
    }),
  }));
}
